module.exports = __webpack_public_path__ + "static/media/android_small.a1722844.png";